var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Configure properties")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/integrations/pipelines/details/${_setup.tid}/${_setup.id}`,
                type: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row mb-4" }, [
        _c(
          "div",
          {
            staticClass: "col",
            staticStyle: { height: "200px", "overflow-y": "auto" },
          },
          [
            _c("h5", [_vm._v("Dataset available")]),
            _vm._v(" "),
            _vm._l(_setup.availableDatasetPropertyNames, function (p) {
              return _c(
                "div",
                { staticClass: "input-group input-group-sm mb-1" },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: p, disabled: "" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _setup.handleIncludePipelineDatasetPropertyCommandV1(
                              p
                            )
                          },
                        },
                      },
                      [_vm._v("Include")]
                    ),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("h5", [_vm._v("Dataset included")]),
            _vm._v(" "),
            _vm._l(_setup.datasetProperties, function (p) {
              return _c(
                "div",
                { staticClass: "input-group input-group-sm mb-1" },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: p, disabled: "" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _setup.handleExcludePipelineDatasetPropertyCommandV1(
                              p
                            )
                          },
                        },
                      },
                      [_vm._v("Exclude")]
                    ),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-4" }, [
        _c(
          "div",
          {
            staticClass: "col",
            staticStyle: { height: "200px", "overflow-y": "auto" },
          },
          [
            _c("h5", [_vm._v("Connector available")]),
            _vm._v(" "),
            _vm._l(_setup.availableConnectorPropertyNames, function (p) {
              return _c(
                "div",
                { staticClass: "input-group input-group-sm mb-1" },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: p, disabled: "" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _setup.handleIncludePipelineConnectorPropertyCommandV1(
                              p
                            )
                          },
                        },
                      },
                      [_vm._v("Include")]
                    ),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("h5", [_vm._v("Connector included")]),
            _vm._v(" "),
            _vm._l(_setup.connectorProperties, function (p) {
              return _c(
                "div",
                { staticClass: "input-group input-group-sm mb-1" },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: p, disabled: "" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _setup.handleExcludePipelineConnectorPropertyCommandV1(
                              p
                            )
                          },
                        },
                      },
                      [_vm._v("Exclude")]
                    ),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-4" }, [
        _c(
          "div",
          {
            staticClass: "col",
            staticStyle: { height: "200px", "overflow-y": "auto" },
          },
          [
            _c("h5", [_vm._v("Pipeline available")]),
            _vm._v(" "),
            _vm._l(_setup.availablePipelinePropertyNames, function (p) {
              return _c(
                "div",
                { staticClass: "input-group input-group-sm mb-1" },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: p, disabled: "" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _setup.handleIncludePipelinePropertyCommandV1(
                              p
                            )
                          },
                        },
                      },
                      [_vm._v("Include")]
                    ),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("h5", [_vm._v("Pipeline included")]),
            _vm._v(" "),
            _vm._l(_setup.pipelineProperties, function (p) {
              return _c(
                "div",
                { staticClass: "input-group input-group-sm mb-1" },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: p, disabled: "" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _setup.handleExcludePipelinePropertyCommandV1(
                              p
                            )
                          },
                        },
                      },
                      [_vm._v("Exclude")]
                    ),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }